import { useCallback } from "react";
import lottie from "lottie-web";

export function useLottieAnimation({
  animation,
  loop = true,
}: {
  animation: Record<string, any>;
  loop?: boolean;
}) {
  return useCallback(
    (node: HTMLDivElement) => {
      if (node) {
        lottie.loadAnimation({
          container: node,
          renderer: "svg",
          loop,
          autoplay: true,
          animationData: animation,
        });
      }
    },
    [animation, loop]
  );
}
